import React from "react";
import { trackFieldChecked, trackFieldFilled, trackFieldUnchecked } from "../../segment";
import type { CurvesFormState, FormState, TrialType } from "../../types";

export const trackRegionChange = <PropertyName extends keyof Pick<FormState, "region">>(
  {
    name,
  }: {
    value: FormState[PropertyName];
    name: string;
  },
  trialType: TrialType = "mo"
) => {
  return trackFieldFilled({ inputName: "Region", inputValue: name || "", trialType });
};

export const trackPrimaryProductChange = <PropertyName extends keyof Pick<FormState, "region">>(
  {
    name,
  }: {
    value: FormState[PropertyName];
    name: string | null;
  },
  trialType: TrialType = "mo"
) => {
  return trackFieldFilled({ inputName: "Primary product", inputValue: name ?? "", trialType });
};

export const trackCheckboxChange = (
  property: keyof Pick<CurvesFormState, "subscribeNewsletter" | "apiInterest">,
  trialType: TrialType = "mo"
) => {
  return (event: React.ChangeEvent<HTMLInputElement>) => {
    const { checked } = event.target;
    const track = checked ? trackFieldChecked : trackFieldUnchecked;

    switch (property) {
      case "subscribeNewsletter":
        track("Newsletter", trialType);
        break;
      case "apiInterest":
        track("API", trialType);
        break;
    }
  };
};
